import React, { useEffect, useMemo, useState } from "react";
import { companyService } from "../../app/services";
import { useTranslation } from "react-i18next";

const CompaniesDirectory = () => {
  const { t } = useTranslation();
  const [q, setQ] = useState("");
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  // Location features disabled for now
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [companies, setCompanies] = useState([]);

  // Load categories on mount
  useEffect(() => {
    let cancelled = false;
    companyService
      .getAllCategories()
      .then((res) => {
        if (cancelled) return;
        setCategories(res || []);
        if (res?.length && !category) setCategory(res[0].name || res[0].Name || res[0].id || "");
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  // Geolocation removed (near me)

  // Fetch companies when filters change
  useEffect(() => {
    let cancelled = false;
    if (!category) return;
    setLoading(true);
    setError("");
    debugger;
    companyService
      .getCompaniesByCategoryAndLocationAndCompanyid(category, {}, "")
      .then((res) => {
        if (cancelled) return;
        setCompanies(Array.isArray(res) ? res : []);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e?.message || "Failed to load companies");
      })
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, [category]);

  const filtered = useMemo(() => {
    let data = companies;
    const text = q.trim().toLowerCase();
    if (text) {
      data = data.filter((c) =>
        (c?.name || c?.Name || "").toLowerCase().includes(text) ||
        (c?.username || c?.Username || "").toLowerCase().includes(text) ||
        (c?.category || c?.Category || "").toLowerCase().includes(text)
      );
    }
    return data;
  }, [companies, q]);

  const normalize = (c) => ({
    id: c.id || c.Id || c.username || c.Username,
    name: c.name || c.Name || c.username || c.Username,
    category: c.category || c.Category || "",
    address: c.address || c.Address || "",
    logo: c.logo || c.Logo || null,
    website: c.reference || c.Reference || "",
    distance: (c.distanceFromCurrent || c.DistanceFromCurrent || {})?.crowflies || null,
  });

  return (
    <section style={{ padding: "64px 8%", background: "#fff" }}>
      <h1 style={{ margin: 0, fontWeight: 900, fontSize: 28, color: "#0a2750" }}>
        {t("CompaniesDirectory.Title", { defaultValue: "Emirati Companies Directory" })}
      </h1>
      <p style={{ marginTop: 8, color: "#334155" }}>
        {t("CompaniesDirectory.Subtitle", { defaultValue: "Browse certified companies. Use filters to refine results." })}
      </p>

      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 18, alignItems: "center" }}>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={t("CompaniesDirectory.SearchPlaceholder", { defaultValue: "Search companies..." })}
          style={{ flex: "1 1 260px", minWidth: 220, padding: "10px 12px", borderRadius: 10, border: "1px solid #e5e7eb" }}
        />

        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          style={{ padding: "10px 12px", borderRadius: 10, border: "1px solid #e5e7eb" }}
        >
          {categories.map((c) => {
            const val = c.name || c.Name || c.id || c.Id;
            return (
              <option key={val} value={val}>
                {c.name || c.Name}
              </option>
            );
          })}
        </select>

        {/* Near me and Sort by distance removed */}
      </div>

      <style>{`
        .grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:16px;margin-top:18px}
        @media(max-width:1000px){.grid{grid-template-columns:repeat(2,minmax(0,1fr))}}
        @media(max-width:640px){.grid{grid-template-columns:1fr}}
        .card{border:1px solid #e8eaf2;border-radius:14px;padding:16px;background:#fff;box-shadow:0 8px 20px rgba(0,0,0,.06);display:flex;gap:14px;align-items:flex-start}
        .name{font-weight:800;color:#0a2750;margin:6px 0 0}
        .cta{display:inline-block;background:var(--uae-green);color:#fff;padding:8px 14px;border-radius:10px;text-decoration:none;font-weight:700;white-space:nowrap;margin-left:auto}
        .logo{width:220px;max-width:100%;height:auto;max-height:140px;object-fit:contain;background:#fff;padding:8px;border-radius:10px}
        .left{display:flex;flex-direction:column;gap:8px;align-items:flex-start;flex:1}
        @media(max-width:640px){.card{flex-direction:column;align-items:flex-start}.cta{margin-left:0;margin-top:10px;width:100%;text-align:center}}
      `}</style>

      {error && (
        <div style={{ marginTop: 12, color: "#b91c1c", fontWeight: 600 }}>{error}</div>
      )}
      {loading && (
        <div style={{ marginTop: 12, color: "#475569" }}>{t("CompaniesDirectory.Loading", { defaultValue: "Loading companies..." })}</div>
      )}

      <div className="grid">
        {!loading && filtered.map((cRaw) => {
          const c = normalize(cRaw);
          const website = (c.website || "").startsWith("http") ? c.website : "";
          return (
            <div className="card" key={c.id}>
              <div className="left">
                {c.logo ? (
                  <img className="logo" src={c.logo} alt={c.name} />
                ) : (
                  <div className="logo" style={{
                    display:'grid',placeItems:'center',background:'#f8fafc',color:'#0a2750',fontWeight:800
                  }}>
                    {(c.name||"?").slice(0,1).toUpperCase()}
                  </div>
                )}
                <h3 className="name">{c.name}</h3>
              </div>
              {website && (
                <a className="cta" href={website} target="_blank" rel="noreferrer">
                  {t("CompaniesDirectory.VisitWebsite", { defaultValue: "Visit Website" })}
                </a>
              )}
            </div>
          );
        })}
        {!loading && filtered.length === 0 && (
          <div className="card" style={{ gridColumn: "1/-1", textAlign: "center" }}>
            {t("CompaniesDirectory.NoResults", { defaultValue: "No companies match your filters." })}
          </div>
        )}
      </div>
    </section>
  );
};

export default CompaniesDirectory;
